import { render, staticRenderFns } from "./PersonalCenterPhone.vue?vue&type=template&id=c52a55d6&scoped=true"
import script from "./PersonalCenterPhone.vue?vue&type=script&lang=js"
export * from "./PersonalCenterPhone.vue?vue&type=script&lang=js"
import style0 from "./PersonalCenterPhone.vue?vue&type=style&index=0&id=c52a55d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52a55d6",
  null
  
)

export default component.exports